import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SendMail } from '../../services';

export const fetchSendMail = createAsyncThunk(
    'sendMail/fetchSendMail',
    async ({ name, mail, phone, subject, message }) => {
        const response = await SendMail(name, mail, phone, subject, message)
        return response;
    }
);

const sendMailSlice = createSlice({
    name: 'sendMail',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSendMail.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSendMail.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSendMail.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sendMailSlice.reducer;
